import Vue from 'vue'
import { Form, Input, InputNumber, Spin, Select, Table, Button, Tabs, message, Modal, Divider } from 'ant-design-vue'
import { FlightCitySelector } from 'ace-ui-eking'
Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Spin)
Vue.use(Select)
Vue.use(Table)
Vue.use(FlightCitySelector)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.use(Divider)
